"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDashboardPlate = exports.StyledDashboardPlateFooter = exports.StyledDashboardPlateHeaderBodyWrapper = exports.StyledDashboardPlateBody = exports.StyledDashboardPlateHeader = exports.StyledDashboardPlateHeaderAddonWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
exports.StyledDashboardPlateHeaderAddonWrapper = styled_components_1.default.div `
    display: flex;
    max-height: ${helpers_1.SIZE_XL};
`;
exports.StyledDashboardPlateHeader = (0, styled_components_1.default)(StackView_1.StackView) `
    margin-top: ${helpers_1.SPACING_M};
    margin-bottom: ${helpers_1.SPACING_S};
    height: 20px;
`;
exports.StyledDashboardPlateBody = styled_components_1.default.div `
    overflow: auto;
    margin-top: ${helpers_1.SPACING_S};
`;
exports.StyledDashboardPlateHeaderBodyWrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    ${({ hasViewMore }) => {
    if (hasViewMore) {
        return (0, styled_components_1.css) `
                height: calc(100% - ${helpers_1.SPACING_XL} - ${helpers_1.SPACING_S});
            `;
    }
    return (0, styled_components_1.css) `
            height: 100%;
        `;
}}
`;
exports.StyledDashboardPlateFooter = (0, styled_components_1.default)(StackView_1.StackView) `
    height: ${helpers_1.SPACING_XL};
    margin-bottom: ${helpers_1.SPACING_S};
`;
exports.StyledDashboardPlate = (0, styled_components_1.default)(StackView_1.StackView) `
    display: inline-flex;
    box-sizing: border-box;
    width: 560px;
    height: 368px;

    background-color: #fff;
    box-shadow: 0 3px 6px #00000029;
`;
//# sourceMappingURL=DashboardPlate.styles.js.map